/**
 * @param {jQuery} $target
 * @param {string} activeClass
 * @param {Object[]} hovered {target: Object, activeClass: string}
 * @constructor
 */
function InfoTooltip($target, activeClass, hovered) {
    this.target = $target;
    this.activeClass = activeClass;
    this.hideTO = null;
    this.hovered = hovered;
    this.card = this.target.closest('.js-product');

    var $this = this;

    this.target.find('.products__action-popup-btn--continue').on('click', function (e) {
        e.preventDefault();
        $this.hide();
    });

    this.hovered.forEach(function (item) {
        $target = $(item.target);
        $target.on('mouseenter', function () {
            if ($target.hasClass(item.activeClass)) {
                $this.show();
            }
        });
    });

    this.softHide = function () {
        clearTimeout($this.hideTO);
        $this.hideTO = setTimeout(function () {
            $this.hide();
        }, 5000);
    };
}

InfoTooltip.prototype.show = function () {
    this.target.addClass(this.activeClass);
    this.hideOnHoverEnd();
};

InfoTooltip.prototype.hide = function () {
    this.target.removeClass(this.activeClass);
    this.card.off('mouseenter', this.hideOnHoverEnd);
};

InfoTooltip.prototype.hideOnHoverEnd = function () {
    var $this = this;
    clearTimeout($this.hideTO);

    this.card.one('mouseleave', function () {
        $this.softHide();
    });

    this.card.one('mouseenter', function () {
        $this.hideOnHoverEnd()
    });
};

